/**
 * Component for handling affiliate/partner logic
 * @author Housefolios
 * @modifiedBy David Helmick
 * @modifiedTime 2025-06-17 14:05:00
 */

import React from 'react'
import {
  Grid,
  Typography,
  TextField,
  InputAdornment,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Check } from '@mui/icons-material'

const AffiliateSection = ({
  affiliate,
  setAffiliate,
  affiliateValid,
  setAffiliateValid,
  affiliatePrice,
  affiliateBilling,
  isPaul,
  isGorilla,
  isInvestarters,
}) => {
  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return (
    <Grid container direction="column" spacing={2}>
      <Grid>
        <Typography
          variant="h5"
          style={{
            fontWeight: 600,
          }}
        >
          Affiliate Code
        </Typography>
      </Grid>

      <Grid>
        <TextField
          fullWidth
          label="Affiliate Code"
          variant="outlined"
          value={affiliate}
          onChange={(event) => {
            setAffiliate(event.target.value)
            setAffiliateValid(false)
          }}
          disabled={affiliateValid}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  {affiliateValid ? (
                    <Check
                      style={{
                        color: 'green',
                      }}
                    />
                  ) : (
                    <FontAwesomeIcon icon={['fas', 'xmark']} style={{ color: 'red', }} sx={{ fontSize: "1rem !important" }} />
                  )}
                </InputAdornment>
              ),
            },
          }}
        />
      </Grid>

      <Grid size={12} sx={{ mt: '0.5rem' }}>
        <Grid
          container
          direction="row"
          wrap="nowrap"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid>
            <Typography
              style={{
                fontSize: 22,
                fontWeight: 90,
              }}
              color="primary"
            >
              Total due today
            </Typography>
          </Grid>
          <Grid>
            <Typography
              style={{
                fontSize: 22,
                fontWeight: 900,
              }}
            >
              {currencyFormat.format(affiliatePrice / 100)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <Typography
          style={{
            fontSize: 16,
            fontWeight: 900,
            color: 'red',
          }}
        >
          ***Next payment of{' '}
          {currencyFormat.format(affiliatePrice / 100)} due{' '}
          {isPaul || isGorilla || isInvestarters
            ? '3 Days'
            : affiliateBilling === 'monthly'
              ? 'a month'
              : 'a year'}{' '}
          from now.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default AffiliateSection
